import {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setTriggerOfferCheckFor} from 'modules/accommodation/slice'
import {getRoomDetailOverlayVisibility} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'

import {Offer} from '@daedalus/core/src/offer/types/offer'
import {SplitBooking} from '@daedalus/core/src/room/types/room'

import {useGetComposedOfferCheckAPIParamsBuilder} from './useGetComposedOfferCheckAPIParams'

type Props = {
  offer: {offer?: Offer; splitBooking?: SplitBooking}
}

export const useDefferedOfferInteraction = ({offer}: Props) => {
  const isRoomsDetailsOverlayOpen = useSelector(getRoomDetailOverlayVisibility)
  const {buildOfferCheckParams} = useGetComposedOfferCheckAPIParamsBuilder()
  const dispatch = useDispatch()
  const defferedOfferClick = useCallback(
    (landingUrl: string) => {
      const apiParams = buildOfferCheckParams(offer)

      if (isRoomsDetailsOverlayOpen) {
        dispatch(hideOverlay())
      }

      dispatch(
        setTriggerOfferCheckFor({
          ...offer,
          //for initial simplicity - storing all query params in the state
          params: apiParams,
          landingUrl
        })
      )
    },
    [buildOfferCheckParams, offer, isRoomsDetailsOverlayOpen, dispatch]
  )

  return {
    defferedOfferClick
  }
}
